import axios from "axios";

export default {
    name: "bidbond",
    state: {
        list: Array,
        bank: Array,
        noBidBond: Array,
    },
    getters: {
        getListBidBond: state => {
            return state.list
        },
        getListBankBidBond: state => {
            return state.bank
        },
        getListnoBidBond: state => {
            return state.noBidBond
        },
    },
    mutations: {
        setListBidBond: (state, payload) => {
            state.list = payload
        },
        setListBankBidBond: (state, payload) => {
            state.bank = payload
        },
        setListnoBidBond: (state, payload) => {
            state.noBidBond = payload
        },
    },
    actions: {
        getListBankBidBond(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "main/bank_account",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListBankBidBond", response.data.bank_account);
                        resolve(response.data.bank_account);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getListnoBidBond(store, { auth,type }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond/bidbond",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username,
                        type: type
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListnoBidBond", response.data.bidbond);
                        resolve(response.data.bidbond);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        getListBidBond(store, { auth }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "get",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond",
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    params: {
                        tlc: auth.username
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                    },
                })
                    .then((response) => {
                        store.commit("setListBidBond", response.data.data);
                        resolve(response.data.data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        submitBidBond(store, { auth, payload }) {
            return new Promise((resolve, reject) => {
                axios({
                    method: "post",
                    url: process.env.VUE_APP_SERVICEURL + "bidbond",
                    data: payload,
                    auth: {
                        username: auth.username,
                        password: auth.password,
                    },
                    headers: {
                        "X-API-KEY": auth.apikey,
                        "Content-Type": "multipart/form-data",
                    },
                })
                    .then(({ data }) => {
                        resolve(data);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
